import React from 'react';
import LandingPage from '../components/LandingPage';
import BookDetails from '../components/BookDetails';
import AuthorInfo from '../components/AuthorInfo';
import Action from '../components/Action';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";
// Import the background image
import backgroundImage from './nemia_new_web.jpg';  // Adjust the path based on your file structure

const Landing = () => (
  <>
    <div class="container" style={{
      backgroundImage: `url(${backgroundImage})`,
      backgroundSize: "cover",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "bottom",
      minHeight: "100vh",
      color: "#fff"
    }}>
      <main >
        <LandingPage />
      </main>
      <Footer />
      {/* the react-helmet establishes the per page Title (browser tab short text) */}
      {/* it should also be usable to override other per page meta data, but the description below is not working...? -3/12/26 */}
      <Helmet>
        <meta name="description" content="audiobook available" />
        <title>Novels by Michael Goe</title>
      </Helmet>
    </div>
  </>
);

export default Landing;
